import { render, staticRenderFns } from "./CaptiveFormsModalGeneral.vue?vue&type=template&id=b19d8888"
import script from "./CaptiveFormsModalGeneral.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsModalGeneral.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsModalGeneral.vue?vue&type=style&index=0&id=b19d8888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports